import { useEffect, useState } from 'react';

// 행정구역(대구·경북) 데이터는 처음 필요할 때 한 번만 불러옵니다 (별도 청크, 브라우저 캐시).
let promise;
export const loadRegions = () => (promise ||= import('../data/regions.json').then(m => m.default || m));

export function useRegions() {
  const [data, setData] = useState(null);
  useEffect(() => { let on = true; loadRegions().then(d => on && setData(d)); return () => { on = false; }; }, []);
  return data;
}

export function findRegion(data, { sido, sgg, emd }) {
  const s = data?.sido.find(x => x.id === sido);
  const g = s?.g.find(x => x.id === sgg);
  const e = g?.e.find(x => x.id === emd);
  const target = e || g || s;
  if (!target) return null;
  return { key: target.id, label: [s?.n, g?.n, e?.n].filter(Boolean).join(' '), short: e?.n || g?.n || s?.n, center: target.c, bounds: target.b, level: e ? 'emd' : g ? 'sgg' : 'sido' };
}
